import { SvgIcon, SvgIconProps } from '@mui/material';

const ShareOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="ShareOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.05946 17.9825C1.03019 18.2809 1.01534 18.5238 1.0078 18.6951L1 18.98L1 21.499L2.72778 19.6659L2.73143 19.662L2.74927 19.6434C2.7658 19.6262 2.79149 19.5997 2.82585 19.5648C2.8946 19.495 2.99795 19.3917 3.132 19.2623C3.40039 19.0032 3.79028 18.6412 4.27069 18.2351C5.23885 17.4165 6.54202 16.4466 7.93721 15.7683C9.2865 15.1123 10.7783 14.8386 11.9619 14.7351C12.3536 14.7009 12.7056 14.6857 12.9999 14.6808L12.9999 19.9066L22.9295 11.2172L12.9999 2.49288L12.9999 7.61202C12.4614 7.58841 11.7625 7.5873 10.9737 7.65758C9.18416 7.81699 6.83903 8.35218 4.87558 9.92151C2.88186 11.515 1.93035 13.8279 1.46836 15.6438C1.23444 16.5633 1.11786 17.3872 1.05946 17.9825ZM14.0831 12.7061L14.9999 12.7826L14.9999 15.4987L19.8959 11.2142L14.9999 6.91244L14.9999 9.87478L13.844 9.69044L13.6651 9.66744C13.5377 9.65294 13.3468 9.63437 13.1048 9.62002C12.6195 9.59124 11.9357 9.57979 11.1511 9.64969C9.56561 9.79093 7.66076 10.2557 6.12428 11.4838C4.61806 12.6877 3.81962 14.5135 3.40662 16.1369C3.38337 16.2283 3.36144 16.3187 3.34076 16.4079C4.33682 15.5964 5.63754 14.6625 7.06274 13.9696C8.71325 13.1672 10.4714 12.8578 11.7878 12.7427C12.4515 12.6847 13.0164 12.6749 13.4184 12.6799C13.6197 12.6823 13.7809 12.6885 13.8942 12.6942L14.0831 12.7061Z"
      />
    </SvgIcon>
  );
};

export default ShareOutlined;
